/**
 * Theme bond accessor.
 *
 * Bond packages (e.g. `@molecule/app-theme-css-variables`) call
 * `setProvider()` during setup. Application code uses `getProvider()`
 * to read and switch themes, toggle dark/light mode, and subscribe
 * to theme changes.
 *
 * @module
 */
import { bond, get as bondGet, isBonded } from '@molecule/app-bond';
const BOND_TYPE = 'theme';
/**
 * Registers a theme provider as the active singleton.
 *
 * @param provider - The theme provider implementation to bond.
 */
export const setProvider = (provider) => {
    bond(BOND_TYPE, provider);
};
/**
 * Retrieves the bonded theme provider, or `null` if none is configured.
 *
 * @returns The bonded theme provider, or `null`.
 */
export const getProvider = () => bondGet(BOND_TYPE) ?? null;
/**
 * Checks whether a theme provider is currently bonded.
 *
 * @returns `true` if a theme provider is bonded.
 */
export const hasProvider = () => isBonded(BOND_TYPE);
//# sourceMappingURL=provider.js.map